import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { Observable } from 'rxjs';
import { selectAppointment, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { CommonActions } from 'src/app/common/store/actions/common.actions';
import { AppFunctions } from '../../constants/app-functions';
import { CommonBasicData } from '../../constants/common-basic-data';
import { Appointment } from '../../models/appointment.model';
import { ObjectData } from '../../models/object-data.model';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@Component({
    selector: 'app-appointment-dialog',
    templateUrl: './appointment-dialog.component.html',
    styleUrls: ['./appointment-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatSlideToggleModule, MatIconModule, MatDatepickerModule, MatSelectModule]
})
export class AppointmentDialogComponent implements OnInit{

  currentUserId$ : Observable<string>;
  currentUserId: string = "";
  
  appointment$ : Observable<Appointment | undefined>;
  appointment: Appointment = new Appointment();

  //disabled = false;

  serviceTypes = CommonBasicData.serviceTypes;
  locationModes = CommonBasicData.locationModes;

  isReschedule: boolean = false;
  
  constructor(
    public dialogRef: MatDialogRef<AppointmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectData,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

      this.currentUserId$ = store.select(selectLoggedInUserDataId);
      this.appointment$ = store.select(selectAppointment( data.objectSource, data.offerId, data.objectId )); 
      
    }

    ngOnInit(): void {
      //this.isReschedule = (this.data.rescheduleDate ==='1');
      this.currentUserId$.subscribe(
          (id: string) => this.currentUserId = id
      );

      this.appointment$.subscribe(
        (result: Appointment | undefined) => {
          if(result == undefined){
            this.appointment = new Appointment()
            this.appointment.offerId = this.data.offerId;
          }
          else{
            this.appointment = Object.assign(new Appointment(), result)
          }
          //this.reply = ""
        }
      );
    } 
  
    onNoClick(): void {
      this.dialogRef.close();
    }

    submitAppointment(){

      if(this.appointment.id === 0){
        console.log('new')
        this.store.dispatch(CommonActions.appointmentNewSubmit({ appointment: this.appointment, objectSource: this.data.objectSource }));
      }
      else{
        if(this.isReschedule){
          console.log('reschedule')
          this.store.dispatch(CommonActions.appointmentRescheduleSubmit ( { appointmentId: this.appointment.id, rescDate: this.appointment.rescheduleDate, objectSource: this.data.objectSource }));
        }
  
        else{
          console.log('update')
          this.store.dispatch(CommonActions.appointmentUpdateSubmit({ appointment: this.appointment, objectSource: this.data.objectSource }));         
        } 
      }
      this.dialogRef.close();
    }

    dateFormat(dt: string): string{
    
      return AppFunctions.stringToDatetime(dt);
    }
}
